import { ApplicationType } from '../constants/application-type';

export type ContentfulSettings = {
  space: string;
  accessToken: string;
  environment: string;
  preview: boolean;
  application: string;
};

export type ContentfulGraphSettings = {
  graphEndpoint: string;
  bearerToken: string;
};

export type ApplicationBranding = {
  primaryColor: string;
  primaryHoverColor: string;
  primaryActiveColor: string;
};

export class ApplicationSettings {
  googleApiKey?: string;
  b2cFlag?: boolean;
  branding: ApplicationBranding;
  applicationType?: ApplicationType;
  constructor(
    googleApiKey: string,
    branding: ApplicationBranding,
    applicationType: ApplicationType,
  ) {
    this.googleApiKey = googleApiKey;
    this.branding = branding;
    this.applicationType = applicationType;
    this.b2cFlag = applicationType !== ApplicationType.PartnerPortal;
  }
}
